import Cookies from 'universal-cookie';
import isLocalhost from './isLocalhost';
import isServer from './isServer';

export const cookies = new Cookies();

export const getCrossDomainOptions = (options = {}, req) => {
  const hostname = isServer() ? req.hostname : window.location.hostname;
  return {
    // using .codespark domain will allow access for all subdomains, which unfortunately also includes
    // the alpha and dev envs but it is only way for cookie to be accessed on the subdomains
    domain: isLocalhost() ? hostname : '.codespark.com',
    path: '/',
    ...options,
  };
};

export const setCrossDomainCookie = (name, value, options = {}) => {
  cookies.set(name, value, getCrossDomainOptions(options));
};



// WEBPACK FOOTER //
// ./src/utils/cookieUtils.js